export const SecureStoreKeys = {
    id: "userId",
    jwtToken: "jwtToken",
    refreshToken: "refreshToken",
}

export const Icons = {
    client: "emoticon",
    lawyer: "school",
}
